module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fm_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TABLE OF MONEY VALUES")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraCenter1"
  }, [_vm._v("1 florin [or gulden] = 60 kreuzer")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1"
  }, [_vm._v("1 ducat = 4 1/2 florins")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1"
  }, [_vm._v("1 Reichsthaler = 1 1/2 florins")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1"
  }, [_vm._v("1 friedrich d’or = 7 to 8 florins")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1"
  }, [_vm._v("1 sequin = 2.8 florins")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1"
  }, [_vm._v("1 English shillings = 1 florin")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1"
  }, [_vm._v("1 English pound =\"10\" florins")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1"
  }, [_vm._v("1 louis d’or = 9 to 10 florins")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_vm._v("Rates vary somewhat owing to currency fluctuations.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab24982","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tableof.vue
// module id = 75
// module chunks = 0